
var teaser = document.querySelectorAll('.teaser__wrap');

Array.prototype.forEach.call(teaser, function (teaseritem) {
  var down,
      up,
      link = teaseritem.querySelector('.teaser__heading a'); // let teasercta = teaseritem.querySelector('.teaser__cta');
  // teaseritem.style.cursor = 'pointer';
  // teasercta.style.display = 'block';

  teaseritem.onmousedown = function () {
    return down = +new Date();
  };

  teaseritem.onmouseup = function () {
    up = +new Date();

    if (up - down < 200) {
      link.click();
    }
  };
});

$(document).ready(function(){

/*

	$(".teaser").each( function(){

		// console.log( $(".teaser__heading a",this).length + " _ " + $(".teaser__heading a",this).text() );

		if ( $(".teaser__heading a",this).length ) {

			$(this).addClass("teaser--has-link");


			// $(".teaser__heading a",this).css("color","red");
			// $(".teaser__wrap",this).css("cursor","pointer");

			// $(this).on("click",function(){

				// $(".teaser__heading a",this).click();

			// });

		}
	});


	$(".teaser--has-link").on("click",function(){

		// alert( $(".teaser__heading a").attr("href") );

		$(".teaser__heading a").click();

	});

*/

	$(".teaser__text ul li a").each( function(){

		$(this).html( '<span class="icon-text"><svg class="icon icon--arrow-right"role="presentation" aria-hidden="true" ><use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#arrow-right" xlink:href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#arrow-right"/></svg>' + $(this).text() + '</span>' );

	});


});